import TableLayout from '../../../../layout/main/TableLayout'
import { Column, Flex, Relative, Row } from '../../../../../styles/CommonStyles'
import { formatName, getNames } from '../../../../../core/utils/common'
import Text from '../../../../../core/utils/Text'
import DateTime from '../../../../common/utils/DateTime'
import Operation from '../../../../common/utils/Operation'
import ModalLayout from '../../../../layout/main/ModalLayout'
import UserLink from '../../../../common/utils/UserLink'
import useGetTableIndex from '../../../../../core/hooks/layout/useGetTableIndex'
import CoinRow from '../../../../common/common/CoinRow'
import { vasAttributes } from '../../../../../core/constants/headers'
import useDuePayments from '../../../../../core/hooks/main/due-payments/useDuePayments'
import BasicModal from '../../../../modals/BasicModal'

const VAsTable = ({ data }) => {
    const { data: vas } = data
    const { cs, headers } = vasAttributes
    const { getTableIndex } = useGetTableIndex()
    const {
        getVasOperation,
        modal,
        onModalClose,
        onOptionClicked,
        approveVaIsLoading,
        handleApprove
    } = useDuePayments()

    return (
        <TableLayout headers={headers} cs={cs} data={data}>
            {vas?.data?.map((item, idx) => {
                const { FULLNAME, NAMEAVATAR } = getNames(
                    item.user?.firstName,
                    item.user?.lastName
                )

                const statusText = item.isOperational
                    ? 'operational'
                    : 'in_review'

                const statusColor = item.isOperational ? 'success' : 'warning'

                return (
                    <Relative key={item._id}>
                        <Row cs={cs} index={idx}>
                            <Column>{getTableIndex(idx)}</Column>

                            {/* USER */}
                            <Column avatar>
                                <UserLink
                                    _id={item.userId}
                                    name={formatName(FULLNAME)}
                                />
                            </Column>

                            {/* ACCOUNT ID */}
                            <Column>
                                <Text tid={item.accountId} />

                            </Column>

                            {/* SCHEMA */}
                            <Column>
                                <Flex>
                                    {item.currency}

                                </Flex>
                            </Column>

                            {/* CURRENCY */}
                            <Column>
                                <CoinRow
                                    coin={{
                                        id: item.currency?.toLowerCase(),
                                        name: item.currency?.toLowerCase(),
                                        fa: item.currency?.toLowerCase()
                                    }}
                                />
                            </Column>

                            {/* STATUS */}
                            <Column>
                                <Text tid={statusText} />
                            </Column>

                            {/* CREATED AT */}
                            <Column>
                                <DateTime dt={item.createdAt} />
                            </Column>
                        </Row>
                        {/* OPERATIONS */}
                        <Column operation>
                            <Operation
                                hasWriteAccess
                                options={getVasOperation(idx)}
                                onOptionClicked={() => { onOptionClicked(idx, item) }}
                            />
                        </Column>

                    </Relative>
                )
            })}

            <ModalLayout
                open={modal.open}
                width="520px"
                onClose={onModalClose}
            >
                <BasicModal
                    head="basic-vas"
                    desc="basic-vas-desc"
                    _id={modal.data?.id}
                    onSubmit={handleApprove}
                    onClose={onModalClose}
                    loading={approveVaIsLoading}
                />
            </ModalLayout>
        </TableLayout>
    )
}


export default VAsTable
